import { FolderTwoTone } from "@ant-design/icons";
import { Card, Checkbox, Col, Image, Row, Spin, Typography } from "antd";
import useStorage from "../../stores/storage";
import SelectAll from "./SelectAll";

interface FileItemProps {
  name: string;
  type: "dir" | "file";
  checked: boolean;
  path: string;
  isSelect?: boolean;
  imageSelected?: () => void;
  handleClickDir: () => void;
  handleCheckboxClick: () => void;
}

const FileItem = ({
  name,
  type,
  checked,
  path,
  isSelect,
  imageSelected,
  handleClickDir,
  handleCheckboxClick,
}: FileItemProps) => {
  const handleDoubleClick = () => {
    if (type !== "dir") return;
    handleClickDir();
  };

  const onImageSelected = () => {
    imageSelected && imageSelected()
  }

  const dirFileItem =
    type === "dir" ? (
      <FolderTwoTone style={{ fontSize: 100 }} />
    ) : (
      <Image
        placeholder
        alt={name}
        src={path}
        height={96}
        preview={false}
        fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
        onClick={onImageSelected}
      />
    );

  return (
    <Card
      bodyStyle={{
        padding: 0,
        width: 150,
        height: 200,
      }}
      bordered={false}
      onDoubleClick={handleDoubleClick}
    >
      {
        isSelect?null:(
          <Checkbox
            style={{
              position: "absolute",
              left: 3,
              top: 0,
              width: "100%",
              height: "100%",
              zIndex: 999,
            }}
            checked={checked}
            onClick={handleCheckboxClick}
          />
        )
      }
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 120,
          height: 120,
          margin: "auto",
        }}
      >
        {dirFileItem}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxHeight: 50,
        }}
      >
        <Typography.Paragraph
          style={{ textAlign: "center", margin: 0 }}
          ellipsis
        >
          {name}
        </Typography.Paragraph>
      </div>
    </Card>
  );
};

const FileGrid = (
  { multiple = true, isSelect, imageSelected }: 
  { multiple?: boolean, isSelect?: boolean, imageSelected?: (item: any) => void }
  ) => {
  const {
    fileList,
    loading,
    setCurrentRef,
    selected,
    setSelected,
    toggleSelected,
  } = useStorage();

  const handleToggleSelected = (id: number) => {
    if (multiple) {
      toggleSelected(id);
    } else if (selected.includes(id) || selected.length === 0) {
      toggleSelected(id);
    } else {
      setSelected([id]);
    }
  };

  const onImageSelected = (item: any) => {
    imageSelected && imageSelected(item)
  }

  if (loading)
    return (
      <div
        style={{
          width: "100%",
          minHeight: 200,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Spin />
      </div>
    );

  return (
    <div style={{ marginLeft: 8, marginRight: 8 }}>
      {multiple && !isSelect && <SelectAll />}
      <Row justify="start" gutter={10} style={{ minHeight: 200 }}>
        {fileList.map((item) => (
          <Col key={item.id}>
            <FileItem
              name={item.name}
              type={item.type}
              path={item.path}
              isSelect={isSelect}
              checked={selected.includes(item.id)}
              imageSelected={() => onImageSelected(item)}
              handleClickDir={() => setCurrentRef(item.id)}
              handleCheckboxClick={() => handleToggleSelected(item.id)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default FileGrid;
